<template>
    <draggable
        class="p-2 border"
        :tag="tag"
        :list="list"
        :group="{ name: group }"
    >
        <template v-for="(el, index) in list">
            <div
                class="border mb-2 shadow bg-light"
                :key="`${el.uid}-${index}`"
                :class="{'collapsed': isCollapsed(collapsed, el.uid)}"
            >
                <div class="d-flex p-1">
                    <b-button
                        variant="link"
                        size="sm"
                        @click="toggleCollapse(el)"
                        >{{ isCollapsed(collapsed, el.uid)? '+':'-' }}</b-button
                    >
                    <label :title="`UID: ${el.uid}`">{{ el.tag || el.id }}</label>
                    <span class="ml-auto">
                        <b-button
                            variant="link"
                            size="sm"
                            class
                            @click="editComponent(el)"
                            >Edit</b-button
                        >
                        <b-button
                            variant="link"
                            size="sm"
                            class
                            @click="renderComponent(el)"
                            >Render</b-button
                        >
                        <b-button
                            variant="link"
                            size="sm"
                            class
                            @click="removeOption(el)"
                            >X</b-button
                        >
                    </span>
                </div>
                <div
                    class="bg-light p-1 rounded border border-aqua small hide-on-drag"
                    v-if="!isCollapsed(collapsed, el.uid)"
                >
                    <span
                        class="mr-1 bg-info text-white p-1 rounded cursor-pointer"
                        v-if="el.tag !== ''"
                        @click="addAttribute({ component: el })"
                    >
                        <i>+</i>
                    </span>
                    <template v-for="(prop, index) in el.props">
                        <span
                            class="mr-1 p-1 rounded cursor-pointer"
                            :class="`type-${prop.renderOption}`"
                            :key="`${prop.name}-${index}`"
                            @click="
                                editAttribute({
                                    component: el,
                                    attribute: prop
                                })
                            "
                        >
                            <template v-if="prop.renderOption === 'noValue'">
                                <i>{{ prop.name }}</i>
                            </template>
                            <i v-else
                                >{{ prop.name }}:{{ prop.value }} ({{
                                    prop.defaultValue
                                }})</i
                            >
                        </span>
                    </template>
                </div>
                <template v-if="!isCollapsed(collapsed, el.uid) && el.slots && Object.keys(el.slots).length">
                    <template v-for="slot in Object.keys(el.slots)">
                        <div :key="slot" class="p-1">
                            <i class="small">slot:{{ slot }}</i>
                            <nested-draggable
                                :list="el.slots[slot]"
                                :group="`${group}`"
                                @render="renderComponent"
                                @edit="editComponent"
                                @edit-attribute="editAttribute"
                                @add-attribute="addAttribute"
                                @remove="removeOption"
                            ></nested-draggable>
                        </div>
                    </template>
                </template>
            </div>
        </template>
    </draggable>
</template>
<script>
import draggable from "vuedraggable";

export default {
    components: {
        draggable
    },
    name: "nestedDraggable",
    props: {
        group: {
            type: String,
            default: "people"
        },
        tag: {
            type: String,
            default: "div"
        },
        list: {
            required: true,
            type: Array
        }
    },
    data() {
        return {
            collapsed: []
        }
    },
    methods: {
        editComponent(item) {
            this.$emit("edit", item);
        },
        renderComponent(item) {
            this.$emit("render", item);
            // console.log('item', item);
        },
        editAttribute(item) {
            this.$emit("edit-attribute", item);
        },
        addAttribute(item) {
            this.$emit("add-attribute", item);
        },
        removeOption(item) {
            this.$emit("remove", item);
        },
        toggleCollapse(item) {
            if (this.collapsed.indexOf(item.uid) === -1) {
                this.collapsed.push(item.uid);
            } else {
                this.collapsed.splice((this.collapsed.indexOf(item.uid)), 1);
            }
        },
        isCollapsed(array, uid) {
            return (array.indexOf(uid) !== -1) ? true : false;
        }
    }
};
</script>

<style lang="scss">
.type-object {
    background-color: aquamarine;
}
.type-dynamic {
    background-color: red;
    color: white;
}
.type-static {
    background-color: green;
    color: white;
}
.type-noValue {
    background-color: gray;
    color: white;
}
.type-boolean {
    background-color: cadetblue;
    color: white;
}
.type-listener {
    background-color: yellow;
    color: black;
}
.type-htmlAttribute {
    background-color: rgb(255, 196, 0);
    color: black;
}
.sortable-ghost .hide-on-drag {
    display: none;
}
.sortable-chosen {
    background-color: aquamarine !important;
}
</style>
